<template>
  <footer class="bg-gray-50 border-t border-gray-200 mt-auto">
    <div class="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row justify-between items-center gap-4">
        <!-- Left: Copyright -->
        <p class="text-gray-600 text-sm">
          © {{ currentYear }} Calmren. All rights reserved.
        </p>

        <!-- Center: Links -->
        <div class="flex items-center gap-6">
          <RouterLink
            to="/contact"
            class="text-gray-600 hover:text-gray-900 text-sm transition-colors"
          >
            Contact
          </RouterLink>
          <a
            href="https://www.linkedin.com/in/carleen-chamberlain/"
            target="_blank"
            rel="noopener noreferrer"
            class="text-gray-600 hover:text-gray-900 text-sm transition-colors"
          >
            LinkedIn
          </a>
        </div>

        <!-- Right: Location -->
        <p class="text-gray-500 text-sm">
          Aotearoa • New Zealand
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink } from 'vue-router'

const currentYear = computed(() => new Date().getFullYear())
</script>
